import '@src/assets/style/main.scss'
import { isEmpty } from '@src/util'
import { DatePicker, Picker, Toast } from 'antd-mobile-v2'
import moment from 'moment'
import React from 'react'
import EndlessList from './endlessList'

export type QueryResultType = { list: Array<any>; total: number }

export type QueryType = { page: number; phone?: string; status?: 0 | 1 | 9 }

type ListTablePropsType = {
  render?: (e: any, i: number, asignCallback: () => void) => React.ReactNode
  action?: (params: QueryType) => QueryResultType | Promise<QueryResultType>
  statusList: Array<{ label: string; value: any }>
  hide?: boolean
}

type ListTableStateType = {
  page: number
  list: any[]
  total: number
  params: {
    phone: string
    status?: any
    date?: moment.Moment
  }
  loading?: boolean
}

export default class ListTable extends React.Component<
  ListTablePropsType,
  ListTableStateType
> {
  ref?: any
  containerRef?: any
  datePickerRef?: any

  constructor(props: ListTablePropsType) {
    super(props)
    this.state = {
      page: 0,
      list: [],
      total: 0,
      params: {
        phone: '',
      },
    }
  }

  async onRefresh(state?: ListTableStateType) {
    const { list, total, page, params } = state || this.state
    if (total && list.length >= total) {
      return
    }
    const newPage = page + 1
    const param: any = {
      ...params,
      page: newPage,
    }
    if (param.date) {
      param.date = param.date.format('yyyy-MM-DD')
    }
    if (isEmpty(param.phone)) {
      delete param.phone
    }
    const { action } = this.props
    if (!action || typeof action !== 'function') {
      return
    }
    this.setState({ loading: true })
    let data = action(param)
    if (data instanceof Promise) {
      data = await data
    }
    this.setState({ loading: false })
    if (data) {
      let _list: any[] = data.list || []
      const _total = data.total || 0
      _list = list.concat(_list)
      this.setState({ total: _total, list: _list, page: newPage })
    } else {
      Toast.fail('数据加载失败...')
    }
  }

  componentDidMount() {
    this.onRefresh()
  }

  filterItemChange(type: 'status' | 'date', value: any) {
    const { params } = this.state
    if (type === 'status') {
      params.status = value
    } else if (type === 'date') {
      params.date = value
    }

    const state = { params, page: 0, list: [], total: 0 }
    this.setState(state)
    this.onRefresh(state)
    this.containerRef?.querySelector('div').scrollTo({ top: 0 })
  }

  asignPersonCallback() {
    const { params } = this.state
    const state = { params, page: 0, list: [], total: 0 }
    this.setState(state)
    this.onRefresh(state)
    this.containerRef?.querySelector('div').scrollTo({ top: 0 })
  }

  render() {
    const { list, params, loading, total } = this.state
    const { render, statusList, hide } = this.props
    const status =
      params.status || params.status === 0 ? [params.status] : undefined
    const noMore = list.length >= total

    const statuses = [{ value: -1, label: '全部' }].concat(statusList)
    const statusText =
      statuses.find((e) => e.value == params.status)?.label || '全部'
    return (
      <div className="m-tab" style={{ display: hide ? 'none' : 'flex' }}>
        <div className="m-query-bar">
          {/* 手机号 */}
          <div className="m-row">
            <input
              className="input"
              value={params.phone}
              placeholder="请输入手机号"
              onChange={(e) => {
                const value = e.target.value
                if (isEmpty(value)) {
                  params.phone = ''
                } else {
                  params.phone = value
                }
                this.setState({ params })
              }}
            />
            <div
              className="btn-search"
              onClick={() => {
                const params = this.state.params
                const state = { params, page: 0, list: [], total: 0 }
                this.onRefresh(state)
              }}
            >
              搜索
            </div>
          </div>
          {/* 分类选择 */}
          <div className="m-row">
            <div className="m-filter-item">
              <span className="btn-selector-label">状态:</span>
              <Picker
                data={statuses}
                value={status}
                extra="全部"
                cols={1}
                onChange={(e) => {
                  let statusValue: any
                  if (e && e.length > 0) {
                    const value: any = e[0]
                    if (value === -1) {
                      statusValue = undefined
                    } else {
                      statusValue = value
                    }
                  } else {
                    statusValue = undefined
                  }
                  this.filterItemChange('status', statusValue)
                }}
              >
                <span className="btn-selector-value">{statusText}</span>
              </Picker>
            </div>
            <div className="m-filter-item">
              <span className="btn-selector-label">日期:</span>
              <DatePicker
                mode="date"
                extra="全部"
                ref={(e) => (this.datePickerRef = e)}
                value={params.date?.toDate()}
                onChange={(v) => {
                  this.filterItemChange('date', v ? moment(v) : undefined)
                }}
                title={
                  <span
                    style={{ color: 'red' }}
                    onClick={(e) => {
                      e.stopPropagation()
                      this.filterItemChange('date', undefined)
                    }}
                  >
                    清理
                  </span>
                }
              >
                <span className="btn-selector-value">
                  {params.date?.format('yyyy/MM/DD') || '全部'}
                </span>
              </DatePicker>
            </div>
          </div>
        </div>
        {/* list body */}
        <div className="m-body" ref={this.containerRef}>
          <EndlessList
            onTouchBottom={this.onRefresh.bind(this)}
            loading={loading}
            noMore={noMore}
          >
            <div className="m-list">
              {list.map((e, i) => {
                return render ? (
                  render(e, i, this.asignPersonCallback.bind(this))
                ) : (
                  <div key={i} />
                )
              })}
            </div>
          </EndlessList>
        </div>
      </div>
    )
  }
}
